// extracted by mini-css-extract-plugin
module.exports = {"jobCard":"jobListFresher_jobCard__Yitmo","searchDiv":"jobListFresher_searchDiv__3JByY"};